import { ApolloCache } from '@apollo/client';

export default (cache: ApolloCache<any>, lifeApplicationId: string) => {
  cache.modify({
    id: cache.identify({
      __typename: 'LifeApplication',
      id: lifeApplicationId,
    }),
    fields: {
      policies(existingPolicies) {
        const updatedPolicies = { ...existingPolicies };

        for (const key in updatedPolicies) {
          if (key.startsWith('quotedPolicies')) {
            updatedPolicies[key] = undefined;
          }
        }

        return updatedPolicies;
      },
    },
  });
  cache.gc();
};
